import type { GridProps, HTMLChakraProps } from '@chakra-ui/react';
import {
  Box, Grid, Flex, Image, Text, Link,
  chakra,
} from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';

const Footer = () => {
  const renderProjectInfo = React.useCallback((gridArea?: GridProps['gridArea']) => {
    return (
      <Box gridArea={ gridArea }>
        <Flex columnGap={ 2 } fontSize="xs" lineHeight={ 5 } alignItems="center" color="text">
          <Box
            as="a"
            href={ route({ pathname: '/' }) }
            width={{ base: '120px' }}
            height={{ base: '24px' }}
            display="inline-flex"
            overflow="hidden"
            flexShrink={ 0 }
            aria-label="Link to main page"
          >
            <Image
              w="auto"
              h="100%"
              src="/static/taostats.svg"
              alt="Taostats logo"
              display={{ base: 'block' }}
            />
          </Box>
        </Flex>
        <Text mt={ 3 } fontSize="xs">
          taostats is a Block Explorer and Analytics Platform for Bittensor, a decentralized machine learning network.
        </Text>
      </Box>
    );
  }, []);

  const containerProps: HTMLChakraProps<'div'> = {
    as: 'footer',
    borderTopWidth: '1px',
    borderTopColor: 'solid',
  };

  const contentProps: GridProps = {
    px: { base: 4, lg: config.UI.navigation.layout === 'horizontal' ? 6 : 12, '2xl': 6 },
    py: { base: 4, lg: 8 },
    gridTemplateColumns: { base: '1fr', lg: 'minmax(auto, 470px) 1fr' },
    columnGap: { lg: '32px', xl: '100px' },
    maxW: `${ CONTENT_MAX_WIDTH }px`,
    m: '0 auto',
  };

  if (config.UI.footer.links) {
    return (
      <Box { ...containerProps }>
        <Grid { ...contentProps }>
          <div>
            { renderProjectInfo() }
          </div>

          <TaostatsFundingInfo/>

        </Grid>
      </Box>
    );
  }

  return (
    <Box { ...containerProps }>
      <Grid
        { ...contentProps }
        gridTemplateAreas={{
          lg: `
          "info funding-info"
        `,
        }}
      >
        { renderProjectInfo({ lg: 'info' }) }

        <Box gridArea={{ lg: 'funding-info' }} justifySelf={{ lg: 'flex-end' }}>
          <TaostatsFundingInfo/>
        </Box>
      </Grid>
    </Box>
  );
};

const TaostatsFundingInfo = () => {
  return (
    <div>
      <Text
        fontSize="xs"
        color="text_secondary"
        textAlign={{ base: 'left', lg: 'right' }}
        mt={{ base: '10px', lg: 0 }}
      >
        taostats is funded by public delegation. Support us by delegating stake to the{ ' ' }
        <Link
          href="https://delegate.taostats.io/staking?hkey=5Hddm3iBFD2GLT5ik7LZnT3XJUnRnN8PoeCFgGQgawUVKNm8"
          color="link"
          textDecoration="underline"
          isExternal
        >
          <chakra.span style={{ color: '#00dbbc' }}>taostats.io</chakra.span>
          { ' ' }validator
        </Link>
      </Text>
    </div>
  );
};

export default React.memo(Footer);
